import React from "react";
import { motion } from "framer-motion";
import { BriefcaseIcon } from "@heroicons/react/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import projects from "../../data/data.json";

const featuredTitles = [
  "ExchangePal",
  "FixRite",
  "Nigeria Identity Verification",
  "HyvePay",
  "Chat-with-PDF",
  " Toria Spices",
];

const work = featuredTitles
  .map((title) => projects.find((project) => project.title === title))
  .filter(Boolean);

const CodehouzeWork = () => {
  return (
    <section id="work" className="py-24 bg-gray-900 relative">
      <div className="mx-auto max-w-6xl px-6">
        <div className="flex flex-col items-center mb-16">
          <BriefcaseIcon className="w-8 h-8 text-codehouzeOrange mb-4" />
          <h2 className="text-3xl sm:text-4xl font-bold text-white">Selected Work</h2>
          <div className="codehouze-divider" />
          <p className="text-gray-400 text-base mt-4 max-w-xl text-center">
            Real products we've designed, built, and shipped to production,
            not mockups.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {work.map((project, i) => (
            <motion.a
              key={project.title}
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group relative rounded-2xl bg-white/[0.03] border border-white/10 hover:border-codehouzeOrange/40 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-codehouzeOrange/5 overflow-hidden"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={project.image}
                  alt={project.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent opacity-70" />
              </div>
              <div className="p-5">
                <h3 className="text-white font-semibold text-lg mb-1">
                  {project.title.trim()}
                </h3>
                <p className="text-gray-400 text-sm mb-4 line-clamp-2">
                  {project.description}
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.Stack.slice(0, 3).map((stack) => (
                    <span
                      key={stack}
                      className="text-xs bg-codehouzeOrange/10 text-codehouzeOrangeLight border border-codehouzeOrange/20 px-2 py-0.5 rounded-full"
                    >
                      {stack}
                    </span>
                  ))}
                </div>
                <span className="text-codehouzeOrangeLight text-sm font-medium inline-flex items-center gap-2 group-hover:text-white transition-colors">
                  View live
                  <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-xs" />
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CodehouzeWork;
